@if (data$ | async; as data) {
  <div class="faq-item">
    @if (data.anchorId) {
      <a class="anchor" [id]="data.anchorId">{{ data.title }}</a>
    }
    <button
      type="button"
      class="faq-item-question"
      (click)="collapse.toggle()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="collapseExample">
      {{ data.title }}
      @if (isCollapsed) {
        <i class="aimo-icon icon-sm icon-petrol-blue icon-plus-bold"></i>
      }
      @if (!isCollapsed) {
        <i class="aimo-icon icon-sm icon-petrol-blue icon-minus-bold"></i>
      }
    </button>
    <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
      <div class="faq-item-answer" [innerHTML]="data.text|safeHtml"></div>
      <div class="faq-item-media">
        @if (data.image?.url) {
          <cx-media [container]="data.image"></cx-media>
        }
        @if (data.youtubeId) {
          <youtube-player videoId="{{ data.youtubeId }}"></youtube-player>
        }
      </div>
    </div>
  </div>
}
